var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGalleryArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_128_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.37788 0.415566L15.6958 9.72427C15.8064 9.83509 15.885 9.95514 15.9314 10.0844C15.9779 10.2137 16.0007 10.3522 16 10.5C16 10.6478 15.9771 10.7863 15.9314 10.9156C15.8857 11.0449 15.8072 11.1649 15.6958 11.2757L6.37788 20.6121C6.11981 20.8707 5.79723 21 5.41014 21C5.02304 21 4.69124 20.8615 4.41475 20.5844C4.13825 20.3074 4 19.9842 4 19.6148C4 19.2454 4.13825 18.9222 4.41475 18.6451L12.5438 10.5L4.41474 2.35488C4.15668 2.0963 4.02765 1.77752 4.02765 1.39852C4.02765 1.01953 4.1659 0.691873 4.44239 0.415567C4.71889 0.138522 5.04147 -9.49324e-07 5.41013 -9.81553e-07C5.7788 -1.01378e-06 6.10138 0.138522 6.37788 0.415566Z",
    fill: "#4201FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_128_318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 21,
    fill: "white",
    transform: "translate(20 21) rotate(180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryArrow);
export default __webpack_public_path__ + "static/media/gallery-arrow.fc50b7d87c31785df208fa4ecaeb5f4c.svg";
export { ForwardRef as ReactComponent };